<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>

    <div class="center" fusePerfectScrollbar>


        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">


            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'ROLE_LIST' | translate}}</span>
            </div>

            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>


            <div class="row">

            </div>

        </div>


        <div class="content-card my-16" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" fusePerfectScrollbar>

                    <ng-container matColumnDef="index">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>No</mat-header-cell>
                        <mat-cell *matCellDef="let role; let i = index">{{i + 1 + paginator.pageSize *
                            paginator.pageIndex}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef>{{'ID'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let role">
                            {{role.id!=null?role.id:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef>{{'NAME'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let role">
                            {{role.name!=null?role.name:'---'}}
                        </mat-cell>
                    </ng-container>



                    <ng-container matColumnDef="setting">
                        <mat-header-cell *matHeaderCellDef>{{'SETTINGS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let role">
                            <button *ngIf="role.id!=-1" mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="roleMenuClick(role)">
                                    <mat-icon>edit</mat-icon>
                                    <span>{{'MENU_DEFINE'|translate}}</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let role; columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>
                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>

</div>